import React, { useState, useEffect } from "react";
import TopBar from "../../components/layout/TopBar";
import FooterBar from "../../components/layout/FooterBar";
import ApiDocsPage from "../dashboard/components/pages/apikeys/ApiDocsPage";
import "./LandingPageNew.css";

const ApiDocsPublicPage = () => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem("theme");
    return saved || "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="landing-page-new">
      <TopBar theme={theme} toggleTheme={toggleTheme} />
      <main style={{ minHeight: "calc(100vh - 160px)", padding: "100px 20px 40px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <ApiDocsPage />
        </div>
      </main>
      <FooterBar theme={theme} />
    </div>
  );
};

export default ApiDocsPublicPage;
